import React from 'react';
import Navbar from '../../Shared/Navbar/Navbar';
import Header from '../Header/Header';
import HomeBody from '../HomeBody/HomeBody';

const Home = () => {
    return (
        <div>
            <Navbar></Navbar>
            <Header></Header>
            <HomeBody></HomeBody>

            
        </div>
    );
};

export default Home;